import { baseBackend } from "../../../../api/base/baseUrl";

const CANCELLATION_REASON_URL = "/api/v2/cancellation/reasons";

export async function createCancellationReasonRequest(payload) {
  const response = await baseBackend.post(CANCELLATION_REASON_URL, payload);
  return response.data;
}

export async function getCancellationReasonListRequest() {
  const response = await baseBackend.get(CANCELLATION_REASON_URL);
  return response.data;
}

export async function updateCancellationReasonRequest(payload) {
  const response = await baseBackend.put(CANCELLATION_REASON_URL, payload);
  return response.data;
}

export async function deleteCancellationReasonRequest(id) {
  const response = await baseBackend.delete(`${CANCELLATION_REASON_URL}/id/${id}`);
  return response.data;
}
